import React from "react";
import { Minus, Plus } from "lucide-react";
import { fmt } from "../lib/api";

const KIND_LABEL = { product: "Cookie", brownie: "Brownie", cupcookie: "Cupcookie", limited: "Édition limitée", box: "Box composée", prepared_box: "Box", giftcard: "Carte cadeau" };

export function CartLine({ item, prefix, updateQty, removeFromCart }) {
  const dec = () => (item.quantity <= 1 ? removeFromCart(item.line_id) : updateQty(item.line_id, item.quantity - 1));
  return (
    <li className="cs-cl" data-testid={`${prefix}-item-${item.line_id}`}>
      <style>{CL_CSS}</style>
      <div className="cs-cl-ph">{item.image && <img loading="lazy" decoding="async" src={item.image.startsWith("/api/files/") ? `${item.image}?w=220` : item.image} width="220" height="220" alt={item.name} />}</div>
      <div className="cs-cl-info">
        <b>{item.name}</b>
        {KIND_LABEL[item.kind] && <span>{KIND_LABEL[item.kind]}</span>}
        {item.composition && item.composition.map((c, i) => (
          <small key={i}>{c.name}{c.quantity ? ` × ${c.quantity}` : ""}{c.price > 0 ? (item.kind === "box" ? ` (supplément +${fmt(c.price)}/pièce)` : ` (+${fmt(c.price)})`) : ""}</small>
        ))}
        {item.gift && <small data-testid={`${prefix}-gift-names-${item.line_id}`}>Pour {item.gift.recipient_name}{item.gift.sender_name ? ` · de la part de ${item.gift.sender_name}` : ""}</small>}
        <span className="cs-cl-price" data-testid={`${prefix}-price-${item.line_id}`}>{fmt(item.unit_price * item.quantity)}</span>
      </div>
      <div className="cs-cl-qty">
        <button data-testid={`${prefix}-dec-${item.line_id}`} aria-label={item.quantity <= 1 ? "Retirer" : "Moins"} onClick={dec}><Minus size={16} /></button>
        <output data-testid={`${prefix}-qty-${item.line_id}`}>{item.quantity}</output>
        <button data-testid={`${prefix}-inc-${item.line_id}`} aria-label="Plus" onClick={() => updateQty(item.line_id, item.quantity + 1)}><Plus size={16} /></button>
      </div>
      <button className="cs-cl-rm" data-testid={`${prefix}-remove-${item.line_id}`} onClick={() => removeFromCart(item.line_id)}>Retirer</button>
    </li>
  );
}

const CL_CSS = `
.cs-cl{list-style:none;position:relative;background:#fff;border-radius:22px;padding:14px;display:flex;align-items:center;gap:14px;box-shadow:0 1px 2px rgba(43,26,18,.04);font-family:'Bricolage Grotesque',ui-sans-serif,system-ui,sans-serif}
.cs-cl-ph{width:80px;height:80px;flex:none;border-radius:14px;overflow:hidden;background:#F6EADF}
.cs-cl-ph img{width:100%;height:100%;object-fit:cover}
.cs-cl-info{flex:1;min-width:0;background:#F6EADF;border-radius:18px;padding:14px 16px;display:flex;flex-direction:column;gap:3px}
.cs-cl-info b{font-size:16px;line-height:1.2;color:#2B1A12;font-weight:700;letter-spacing:-0.01em}
.cs-cl-info span{font-size:14px;color:#6E5546}
.cs-cl-info small{font-size:12px;color:#8A7262;line-height:1.3}
.cs-cl-info .cs-cl-price{color:#6E5546;font-size:14.5px;margin-top:4px;font-variant-numeric:tabular-nums}
.cs-cl-qty{display:flex;align-items:center;gap:8px;flex:none}
.cs-cl-qty button{width:36px;height:36px;border-radius:999px;border:1.5px solid #2B1A12;background:transparent;color:#2B1A12;display:grid;place-items:center;cursor:pointer;transition:background-color .15s,color .15s}
.cs-cl-qty button:hover{background:#2B1A12;color:#fff}
.cs-cl-qty output{min-width:16px;text-align:center;font-weight:800;font-size:16px;color:#2B1A12}
.cs-cl-rm{position:absolute;right:16px;bottom:6px;border:0;background:transparent;font-size:11px;color:#B9A590;cursor:pointer;padding:0;text-decoration:underline}
.cs-cl-rm:hover{color:#C53030}
@media (max-width:420px){.cs-cl{gap:10px;padding:10px}.cs-cl-ph{width:64px;height:64px}.cs-cl-info{padding:10px 12px}.cs-cl-qty{gap:4px}.cs-cl-qty button{width:30px;height:30px}}
.cs-cl-qty button{position:relative}.cs-cl-qty button::after{content:"";position:absolute;inset:-7px;border-radius:999px}
`;
